import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from 'graphql-request';
export var appPreCheckQuery = () => gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query AppPreCheck($scheme: Scheme!) {\n    appPreCheck(scheme: $scheme) {\n      isTetheredUser\n      applicationGuid\n    }\n  }\n"])));